// src/App.js
import React from 'react';
// BrowserRouter, Routes, Route 외에 Navigate를 추가로 import합니다.
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ChatApp from './ChatApp';
import AdminDashboard from './pages/admin/AdminDashboard.js';
import AdminLogin from './pages/admin/AdminLogin.js'; // 로그인 컴포넌트 import

// 인증 상태를 확인하는 함수
const isAuthenticated = () => {
  // sessionStorage에 'authHeader'가 있는지 확인합니다.
  return sessionStorage.getItem('authHeader') !== null;
};

// 보호된 라우트를 위한 컴포넌트
// 이 컴포넌트는 인증된 사용자만 접근 가능한 페이지를 렌더링합니다.
// 인증되지 않은 경우 로그인 페이지로 리다이렉트합니다.
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    // 사용자가 인증되지 않았으면 '/login' 경로로 리다이렉트합니다.
    // replace 옵션은 브라우저 히스토리에 로그인 페이지를 남기지 않도록 합니다.
    return <Navigate to="/login" replace />;
  }
  // 인증되었으면 요청된 자식 컴포넌트(여기서는 AdminDashboard)를 렌더링합니다.
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 기본 채팅 앱 경로는 누구나 접근 가능 */}
        <Route path="/" element={<ChatApp />} />

        {/* 관리자 로그인 페이지 경로 */}
        <Route path="/login" element={<AdminLogin />} />

        {/* 관리자 대시보드 경로 */}
        {/* ProtectedRoute로 감싸서 인증된 사용자만 접근 가능하도록 합니다. */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* 정의되지 않은 다른 모든 경로는 기본 페이지('/')로 리다이렉트 (선택 사항) */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
